import styled from "styled-components";
import { motion } from "framer-motion";

import { v, t, b } from "../../styles/variables";

export const HeaderHeight = styled.div`
	height: ${v.headerHeight};
`;

export const HeaderFixed = styled.div`
	position: fixed;
	left: 0;
	top: 0;
	height: ${v.headerHeight};
	background: ${({ theme }) => theme.bg};
	z-index: 99;
	width: 100%;
	max-width: 1920px;
	box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);

	header {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		padding: 0 ${v.mediumDist};

		@media ${b.medium} {
			padding: 0 ${v.xLargeDist};
		}

		@media ${b.large} {
			padding: 0 ${v.xxLargeDist};
		}
	}

	.logo {
		font-weight: 700;
		text-transform: uppercase;
		font-size: 2rem;
		font-family: "Aladin", cursive;
		letter-spacing: 0.15rem;

		span {
			font-size: 3rem;
			letter-spacing: -0.5rem;
			-webkit-text-stroke: 0.1px;
			-webkit-text-stroke-color: ${({ theme }) => theme.primary};
			transition: ${t.fastSp};
		}

		&:hover span {
			color: ${({ theme }) => theme.textInvert};
		}
	}

	.theme-switcher {
		width: 60px;
		height: 30px;
		display: none;
		border-radius: 25px;
		background: ${({ theme }) => theme.primary};
		position: relative;
		transition: ${t.fastSp};
		cursor: pointer;
		box-shadow: 0 0 15px ${({ theme }) => theme.primary2};

		.switch-button {
			position: absolute;
			top: 50%;
			transform: translate(-10%, -50%);
			left: 10%;
			background: ${({ theme }) => theme.bg2};
			width: 35%;
			height: 70%;
			border-radius: 25px;
			transition: ${t.fastSp};

			&.clicked {
				left: 60%;
			}
		}

		@media ${b.large} {
			display: block;
		}
	}

	.burger-menu {
		width: 40px;
		height: 40px;
		cursor: pointer;

		.line {
			position: relative;
			height: 4px;
			background: ${({ theme }) => theme.primary};
			margin-bottom: 10px;
			border-radius: 2px;
			transition: ${t.fastSp};

			&:nth-of-type(1) {
				width: 33px;
				transform-origin: left;
			}
			&:nth-of-type(2) {
				right: 0;
				width: 40px;
				transform-origin: right;
			}
			&:nth-of-type(3) {
				margin-bottom: 0;
				transform-origin: left;
				width: 33px;
			}
			&:nth-of-type(4) {
				top: -3px;
				right: 10px;
				margin-bottom: 0;
				transform-origin: right;
				width: 49px;
				transform: rotate(38deg) scaleX(0);
			}
			&:nth-of-type(5) {
				top: -37px;
				right: 10px;
				margin-bottom: 0;
				transform-origin: right;
				width: 49px;
				transform: rotate(322deg) scaleX(0);
			}
		}

		&.close {
			.line {
				&:nth-of-type(1) {
					transform: scaleX(0);
				}
				&:nth-of-type(2) {
					transform: scaleX(0);
				}
				&:nth-of-type(3) {
					transform: scaleX(0);
				}
				&:nth-of-type(4) {
					transform: rotate(38deg) scaleX(1);
					transition-delay: 0.3s;
				}
				&:nth-of-type(5) {
					transform: rotate(322deg) scaleX(1);
					transition-delay: 0.3s;
				}
			}
		}
	}
`;

export const Nav = styled(motion.nav)`
	position: fixed;
	top: ${v.headerHeight};
	right: 0;
	background: ${({ theme }) => theme.bg};
	z-index: 99;
	width: 80%;
	height: calc(100% - ${v.headerHeight});
	padding: ${v.mediumDist};
	box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);

	@media ${b.medium} {
		padding: ${v.xLargeDist};
		width: 30%;
	}

	@media ${b.large} {
		padding: ${v.xxLargeDist};
		width: 20%;
	}

	.switcher-container {
		margin-bottom: 15vh;
		display: flex;
		justify-content: center;

		@media ${b.large} {
			display: none;
		}
	}

	.copyright {
		text-align: center;
		font-size: 1rem;
		color: ${({ theme }) => theme.text2};
	}

	.theme-switcher {
		width: 60px;
		height: 30px;
		border-radius: 25px;
		background: ${({ theme }) => theme.primary};
		position: relative;
		transition: ${t.fastSp};
		cursor: pointer;
		box-shadow: 0 0 15px ${({ theme }) => theme.primary};
		display: flex;

		.switch-button {
			position: absolute;
			top: 50%;
			transform: translate(-10%, -50%);
			left: 10%;
			background: ${({ theme }) => theme.bg2};
			width: 35%;
			height: 70%;
			border-radius: 25px;
			transition: ${t.fastSp};

			&.clicked {
				left: 60%;
			}
		}

		@media ${b.large} {
			display: none;
		}
	}

	ul {
		height: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;

		@media ${b.large} {
			height: 70%;
		}

		a {
			text-transform: uppercase;
			font-weight: bold;
			position: relative;

			&::after {
				content: "";
				position: absolute;
				bottom: -10%;
				left: 0;
				width: 100%;
				height: 3px;
				background: ${({ theme }) => theme.primary};
				transform: scaleX(0);
				transform-origin: right;
				transition: transform 0.3s ease-in;
			}

			&:hover::after {
				transform: scaleX(1);
				transform-origin: left;
			}
		}
	}
`;
